var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"soft-competences-empty-wrapper"},[_c('router-link',{staticClass:"empty-btn",attrs:{"to":{ name: 'professional-skills' }}},[_vm._v("Перейти в каталог")]),_c('div',{staticClass:"empty-icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }